import { useCallback, useEffect, useState } from "react";
import Typed, { TypedOptions } from "typed.js";

const defaultTypedOptions:TypedOptions = {
	typeSpeed: 40,
	backSpeed: 25,
	cursorChar: '│',
	loop: true,
	backDelay: 1000,
  loopCount: Infinity
};

export const useTypedText = (typedOptions: TypedOptions = defaultTypedOptions) => {
  const [target, setTarget] = useState<HTMLDivElement>(null);
  const [options, setOptions] = useState(defaultTypedOptions);

  useEffect(() => {
    setOptions(prev => ({ ...prev, ...typedOptions }))
  }, [typedOptions]);

  const getNode = useCallback((node: HTMLDivElement) => {
    setTarget(node);
  }, []);

  useEffect(() => {
    let typed: Typed;
    if (target && options.strings) {
      typed = new Typed(target, options);
    }
    
    return () => typed?.destroy();
  }, [target, options])

  return { getNode };
}